import type { ReactNode } from 'react';

interface SectionHeadingProps {
  title: string;
  subtitle?: string;
  action?: ReactNode;
}

export default function SectionHeading({ title, subtitle, action }: SectionHeadingProps) {
  return (
    <div className="flex flex-wrap items-end justify-between gap-3 mb-5 md:mb-7">
      <div className="flex items-start gap-3">
        <span className="mt-1 w-1.5 h-6 md:h-7 rounded-full bg-primary-500" />
        <div>
          <h2 className="font-heading text-xl md:text-3xl text-foreground-950 leading-tight">{title}</h2>
          {subtitle ? (
            <p className="mt-1 text-xs md:text-sm text-foreground-500">{subtitle}</p>
          ) : null}
        </div>
      </div>
      {action}
    </div>
  );
}